export const allMainArticles = [
  {
    id: 100,
    title: "Storing my secrets safely on GitHub",
    subtitle: "The day i exposed my secret keys in Git, and how did it solve.",
    dateMonth: "JUN",
    dateNumber: 21,
    minutesRead: 5,
    categories: ["Best Practices", "Web Development", "GitHub"],
    banner:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2FgitEmail.jpg?alt=media&token=b20c6652-834b-424a-8f74-ef2acb66e2ed",
    articleImg:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2FgitEmail.jpg?alt=media&token=b20c6652-834b-424a-8f74-ef2acb66e2ed",
    content:
      "Many days ago, spending time sending commits I was ignored an awarefrom GitHub, lately GitGuardian emailed me on regard security leak, Key exposed with your GitHub account. What happened? Secret keys generated by reCAPTCHA system were exposed in my repository. At first my “solution” was just deleting the .env file where I stored those keys, save changes, commit and push again. however, it didn’t fix security problem. Since git keeps file in the commit, history. Afterward I started searching for a solution in stack overflow, and I came across with git filter-repo API",
    paragrapsArticle: [
      {
        subtitleParagraph:
          "Step by step guideline to remediate the security leak.undefined",
        paragraph: "",
        list: [
          "1.	Revoke the exposed secret keys.",
          "2.	Clean the git history",
          "3.	Inspect Logs.",
        ],
        codeSnippet: {},
        code: "",
      },

      {
        subtitleParagraph: "Step 1: Revoking the secret keys.",
        paragraph:
          "At first i had to remove .env file, so be ensure no one will access the involved service.",
        list: [],
        codeSnippet: {},
        code: "",
      },
      {
        subtitleParagraph:
          "Step 2: Clean the git history (is when git filter-repo comes into play)",
        paragraph:
          "Thankfully, for this simple case, git provides this command that make cleaning things up easy.I recommend you use git-filter-repo, this tool was very useful to rewrite the history of my project in a straightforward way",
        list: [],
        codeSnippet: "",
        code: "",
      },
      {
        subtitleParagraph: undefined,
        paragraph: "First, I installed git-filter-repo in my bash.",
        list: [],
        codeSnippet: [],
        code: "",
      },
      {
        subtitleParagraph: undefined,
        paragraph:
          "To tell git-filter-repo to excise a file from the git history, I use this single command:",
        list: [],
        codeSnippet: {},
        code: "git filter-repo --use-base-name --path [FILENAME] --invert-paths",
      },
      {
        subtitleParagraph: undefined,
        paragraph:
          "The - -use-base-name option tells git-filter-repo that we are specifying a file name, and not a full path to a file. Normally, git-filter-repo command works by ignoring the filenames specified (as the name suggest, in order to filter out). So, I was interested in opposite behavior, we can indicate to ignore everything except the specified file. So we must pass - - invert-paths to indicate this behavior. If you leave off the - - invert-paths, you will excise everything except the file you are specifying, which is exact the opposite case we want, and would likely be a completely mess, so, don’t do that. ",
        list: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: "Step 3: Inspect logs.",
        paragraph:
          "After cleaning, I inspected my Git logs to confirm that the .env file was gone from the history.",
        list: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: undefined,
        paragraph:
          "In conclusion: i think this is not the only or ultimate solution, we should consider different factors such as project size, team geography, and project scope, your may need additional safeguards, though in my specific case, this approach works perfectly. The key lesson I learned were:",

        list: [
          "•	Is a good practice to add the .env file to .gitignore from the very beginning",
          "•	 Revoke compromised keys immediately.",
          "•	Don’t just delete files, instead, make sure they are removed from git history",
        ],
        codeSnippet: {},
        code: "",
      },
      {
        subtitle: undefined,
        paragraph:
          "Mistakes happen, but what matters is learning about them and making sure they don’t happen again.",
        list: [],
        codeSnippet: {},
        code: undefined,
      },
    ],
  },
  {
    id: 101,
    title: "JavaScript Visualized: Promises & Async/Await",
    subtitle: "Loading images and the user experience",
    dateMonth: "AGU",
    dateNumber: 8,
    minutesRead: 5,
    categories: ["Best Practices", "Web Development", "GitHub"],
    banner:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fscreen-articulo-loading%2Fejemplo-media.png?alt=media&token=cecbc66a-0583-4ebc-b932-d7ffb2b45a45",
    articleImg:
      "https://nestify.io/wp-content/webp-express/webp-images/uploads/2024/06/image-89.png.webp",
    balazoArticleImg: "Detail: this is the CardComponent.jsx i built",
    content: (
      <>
        One of the most important things i had been overlooking, while
        developing this portafolio, was the the{" "}
        <strong className="txt-highlighted">
          optimization of media loading,{" "}
        </strong>
        such as videos and images. Interms of user experience, is important to
        ensure that the website remains responsive to any changes that may
        occur. For this reason I decided to manage the{" "}
        <strong className="txt-highlighted"> loading state </strong> in some
        components(images, and video). In the same way as error handling,
        especially when resources are limited or the user has a slow Wi-Fi
        connection (issues like these might happpen),
      </>
    ),

    paragrapsArticle: [
      {
        subtitleParagraph: undefined,
        paragraph: (
          <strong>
            "I tackled this challenge by using the{" "}
            <strong className="txt-highlighted">useState( )</strong> hook,
            asynchronous functions{" "}
            <strong className="txt-highlighted">(async/await)</strong> , and
            promises (new Promise). It's like my program is saying ' I promise
            you to either make a request and display your videos, or shows an
            error message if i'm unable to retrieve the information (due to lack
            of the resource ...etc)'",
          </strong>
        ),
        lista: [],
        codeSnippet: {},
        code: "",
      },

      {
        subtitleParagraph: undefined,
        paragraph: "I consider that a promise can have the following states:",

        lista: [
          {
            txt_item: "Fulfilled – The action was succesfully completed",
            subList: [],
          },
          {
            txt_item: "Rejected – The process failed",
            subList: [],
          },
          {
            txt_item: "Pending – no action has been completed yet. ",
            subList: [],
          },
          {
            txt_item:
              "Settled – The action has either been fulfille or rejected. ",
            subList: [],
          },
        ],
        codeSnippet: {},
        code: "",
      },
      {
        subtitleParagraph: "",
        paragraph:
          "In this case, my promise receives the resolve and reject functions as parameters, if the resoult is successful, I use the .then( ) function; otherwise, if it fails, the .catch( ) function is executed",
        lista: [],
        codeSnippet: {},
        code: "",
      },
      {
        subtitleParagraph: undefined,
        paragraph: (
          <>
            "It's important to keep in mind that the JavaScript environment was
            designed as a{" "}
            <strong style={{ color: "rgba(27, 27, 82, 1)" }}>
              synchronous programming languaje
            </strong>
            , which implies a single thread of execution. As a result of this
            approach: tasks are executed one by one in sequential order. A very
            similar similar situacion happens when your are waiting in the
            checkout line at a grocery store to pay. you can only pay once it's
            your turn.",
          </>
        ),
        lista: [],
        codeSnippet: {},
        code: "",
      },
      {
        subtitleParagraph: undefined,
        paragraph:
          "After this brief introduction, I will show you my solution.",
        list: [],
        codeSnippet: {},
        code: "",
      },
      {
        subtitleParagraph: "Código final documentado - CardContent.jsx",
        paragraph:
          "Here's the full CardContent.jsx component, with explanations of preloading for images/videos and the associated loading state.",
        lista: [],
        codeSnippet: {},
        code: "",
      },
      {
        subtitleParagraph: undefined,
        paragraph: undefined,
        lista: [],
        codeSnippet: {
          alignDiv: "sectionCodeSnippet",
          codeBreakdown: [
            "MediaStatus is an object that stores the loading state of each media element (video and images)",
            "At the very beginnig, all values are set to false, since no loading attempt has been made yet.",
          ],
          codeTitleImg: "✅1.Importaciones y estado inicial",
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fss-importacion-estado-inicial.png?alt=media&token=360ffb5c-ea03-4982-bd8d-4882f20dfb1c",
          balazo: undefined,
        },
        code: undefined,
      },
      {
        subtitleParagraph: "Description:",
        paragraph:
          "1. useEffect is executed when the component is mounted, or when the value assigned to item changes, since item represents each project associated with CardComponent.jsx",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: "1. Video preloading",
        paragraph: "loadMedia( ) is an asynchronous function that:",

        lista: [
          {
            txt_item: "It Creates a <video> element in memory",
            subList: [],
          },
          {
            txt_item:
              "if the componet loads successfully (we use onloadeddata),it updates the videoLoaded state from false to true",
            subList: [],
          },
          {
            txt_item:
              "If it fails, (using onerror), it updates the videoError state from false to true value",
            subList: [],
          },
        ],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: "2. Image preloading",
        paragraph: "",

        lista: [
          {
            txt_item:
              "loadScreenShot() is a function that returns a new Promise",
            subList: [],
          },
          {
            txt_item: "Use new Image( ) to preload the image in memory ",
            subList: [],
          },
          {
            txt_item:
              "If it loads (using onload), it updates the associated state (firstScreenLoaded or secondScreenLoaded)",
            subList: [],
          },
          {
            txt_item:
              "If it fails (with onerror), it updates the error state (firstScreenError or secondScreenError)",
            subList: [],
          },
        ],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: undefined,
        paragraph:
          "3.- Promise.all() loads all my available images more efficiently",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: undefined,
        paragraph: undefined,
        lista: [],
        codeSnippet: {
          alignDiv: "sectionCodeSnippetSingleColumn",
          codeBreakdown: [],
          codeTitleImg: "Precarga de Medios (useEffect)",
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fss-precarga-medios-useEffect-dos.png?alt=media&token=36cfdfa1-7cfe-4d49-8631-c22fc1ea792e",
        },
        code: undefined,
      },

      {
        subtitleParagraph: "Overview:",
        paragraph: undefined,
        lista: [
          {
            txt_item:
              "If there is an error (videoError), a message is displayed.",
            subList: [],
          },
          {
            txt_item:
              "If the video is still loading (!videoLoaded && !videoError), a spinner is shown",
            subList: [],
          },
          {
            txt_item:
              "When the videos is loaded (the state is updated to true: videoLoaded: true), it is displayed with opacity: 1",
            subList: [],
          },
        ],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: undefined,
        paragraph: undefined,
        lista: [],
        codeSnippet: {
          alignDiv: "sectionCodeSnippetSingleColumn",
          codeBreakdown: [],
          codeTitleImg: "🌐 Conditional render 3.1. Video",
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fss-renderizado-condicional-tres.png?alt=media&token=e7cc7c56-5a9b-4dbf-b0f9-861db1f4524d",
        },
        code: undefined,
      },
      {
        subtitleParagraph: "Images explanation",
        paragraph:
          "While the image is still loading (!firstScreenLoaded: true & !FirstScreenError), the Spinner component is displayed. If there is an error (firstScreenError), a pre-configured error message is shown. When the image has loaded successfully (firstScreenLoaded: true) it is displayed with the loaded class",
        lista: [],
        codeSnippet: {
          alignDiv: "",
          codeBreakdown: [],
          codeTitleImg: "",
          codePreview: "",
        },
        code: undefined,
      },
      {
        subtitleParagraph: "Summary of the workflow",
        paragraph: "",
        lista: [
          {
            txt_item:
              "When the component mounts, useEffect( ) executes loadMedia( )",
            subList: [],
          },
          {
            txt_item: "The video and images are preload in the background",
            subList: [],
          },
          {
            txt_item: "When an item is loaded, the mediaStatus is updated",
            subList: [],
          },
          {
            txt_item:
              "React re-render and display the content based on the state",
            subList: [
              "Loading: Spinner",
              "Error: error mesage",
              "Loaded: Video/Imagen visible",
            ],
          },
        ],
        codeSnippet: {},
        code: undefined,
      },

      {
        subtitleParagraph: undefined,
        paragraph: undefined,
        lista: [],
        codeSnippet: {
          alignDiv: "sectionCodeSnippetSingleColumn",
          codeBreakdown: [],
          codeTitleImg: "3.2 Images",
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fscreen-articulo-loading%2Fss-imagenes-wrapper-ultima.png?alt=media&token=590c534d-82d3-4f17-8255-6fe76f5bb07d",
        },
        code: undefined,
      },
      {
        subtitleParagraph: "In conclusion",
        paragraph:
          "For me,  this was a medium complicated level, especially regarding  Promises, Nevertheless I was able to fully grasp the concepts through coding practice. By reinforcing the topics I had learned while writing this summary article, such as state management, promises, and async/await functions – I was able to display contetent al the same time I consider user experience in mind. This also allowed me to improve the user experience by preventing uncertainty when the page contains empty spaces and elements don't seem to make sence. Thank you for reading!",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
    ],
  },
  {
    id: 102,
    title: "React Context & Provider Hooks",
    subtitle: "Toggle Dark/light mode with context Provider and custom hook ",
    dateMonth: "NOV",
    dateNumber: 2,
    minutesRead: 19,
    categories: ["Web Development", "React", "Context API"],
    banner:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fdark_mode_captura.png?alt=media&token=4abb9bc5-58fc-4272-aebe-e14c077e53f4",
    articleImg:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fdark_mode_captura.png?alt=media&token=4abb9bc5-58fc-4272-aebe-e14c077e53f4",
    balazoArticleImg: "Detail: Así se ve el componente en Dark mode",
    content:
      "When I first started building my portfolio website, I wanted users to be able to switch between light and dark themes easily. At first, I thought of handling this using props — but the deeper I got into the project, the more repetitive and messy it became. That’s when I decided to implement React Context to manage the theme globally.",
    paragrapsArticle: [
      {
        subtitleParagraph: "Why Context?",
        paragraph:
          "The Context API in React is a great solution when you need to share data between components without passing props manually at every level. In my case, both the Navbar, Home, and other pages needed to know which theme was active — light or dark — and update their styles accordingly.",
        lista: [],

        codeSnippet: {},
        code: "",
      },

      {
        subtitleParagraph: "",
        paragraph:
          "Using Context allowed me to centralize the logic, simplify component communication, and improve code maintainability.",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: "My Implementation",
        paragraph:
          "I created a single file called ThemeContext.jsx, which exports two things:",
        lista: [
          {
            txt_item: "1.- The context provider (ThemeContextProvider)",
            subList: [],
          },
          {
            txt_item: "2.- A custom hook (useThemeT)",
            subList: [],
          },
        ],
        codeSnippet: {},
        code: undefined,
      },

      {
        subtitleParagraph:
          "Here’s the simplified version of my implementation:",
        paragraph: "",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: undefined,
        paragraph: undefined,
        lista: [],
        codeSnippet: {
          codeBreakdown: [],
          codeTitleImg: "Importaciones y estado inicial",
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Farticulo_context%2F_cambio_main.png?alt=media&token=e03a129e-5f42-42c8-b9ff-507d9df0e12e",
          balazo: undefined,
        },
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph:
          "Now any component in my app can access the current theme and toggle it easily:",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: undefined,
        paragraph: undefined,
        lista: [],
        codeSnippet: {
          codeBreakdown: [],
          codeTitleImg: "---",
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Farticulo_context%2Fconsume-context.png?alt=media&token=9e360292-d923-450a-ae22-64a55cf25985",
          balazo: undefined,
        },
        code: undefined,
      },
      {
        subtitleParagraph: "Debugging: When theme Was Undefined",
        paragraph: "At one point, I ran into this error:",
        lista: [
          {
            subList: ["Can't access property 'bg', theme is undefined"],
          },
        ],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: undefined,
        paragraph:
          "After debugging, I realized that I was passing the value incorrectly to the provider:",
        lista: [],
        codeSnippet: {
          codeBreakdown: [],
          codeTitleImg: "---",
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Farticulo_context%2Ferror.png?alt=media&token=6c3e85ca-22cc-424d-bf54-eadcc48d5af4",
          balazo: undefined,
        },
        code: undefined,
      },
      {
        subtitleParagraph: undefined,
        paragraph:
          "This wrapped the object inside another object. The fix was simple:",
        lista: [],
        codeSnippet: {
          codeBreakdown: [],
          codeTitleImg: " ",
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Farticulo_context%2Fcompuesto.png?alt=media&token=c0e1a87f-bebe-465c-9603-9b98be49f95c",
          balazo:
            "A tiny syntax mistake — but a perfect reminder that the way we structure context values matters a lot.",
        },
        code: undefined,
      },
      {
        subtitleParagraph: "Lessons Learned",
        paragraph:
          "This small implementation taught me that Context is more than a simple global store — it’s a pattern that encourages clean architecture and clear separation of responsibilities.It also reminded me of the importance of understanding how React re-renders and how useMemo helps to optimize unnecessary updates.",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: "Final Thoughts",
        paragraph:
          "Migrating my theme logic to React Context not only made my code more scalable but also more enjoyable to maintain. It’s one of those improvements that seems small at first but makes a huge difference when your app grows.If you’re still passing props manually to handle global state — give Context a try. It’s worth it.",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
    ],
  },
  {
    id: 103,
    title:
      "If There Aren't Any Typos In This Essay, it has been Launched Too Late!  ",
    subtitle:
      "The way for securely transmitting information between parties as a JSON object. ",
    dateMonth: "APR",
    dateNumber: 13,
    minutesRead: 19,
    categories: ["Web Development", "Node.js", "Security"],
    banner: "https://i.ytimg.com/vi/P2CPd9ynFLg/maxresdefault.jpg",
    articleImg: "https://i.ytimg.com/vi/P2CPd9ynFLg/maxresdefault.jpg",
    balazoArticleImg:
      "The truth about Json Web tokens its function in security",
    content:
      "i'm super excited about deepening my understanding of JWT, access tokens, refresh tokens, payloads, signatures, and middleware used to verify tokens issued by custom functions. This idea that has been on my mind for the past few weeks, and now it's finally coming to life. I hope to keep writing on my blog more consistently, yes. i'm back ",

    paragrapsArticle: [
      {
        subtitleParagraph: "What about JSON Web Tokens?",
        paragraph:
          "When we talk about JWT, we need to identify what kind of problem solve them, and, as our first look, is necessary to tackle two main concepts (and differentiate both). The First , it’s Authentication: Imagine! When you log in your bank account. The server check if the user and the password match. And in regard whether user exists, and the password you introduced exists —yet,in the database. The user (you) will be authenticated. And That’s all! You are into. At this point you’re authenticated. And this is where the second concept gets into play. The Authorization; that It’s basically the process of verify your permissions, to access some resources or services you are trying to reach out. For example: Does the user has permission to modify its address, or someone else’s address? ",
        lista: [],

        codeSnippet: {},
        code: "",
      },

      {
        subtitleParagraph: "",
        paragraph:
          "The authorization part, is where I decided to use JWT. These are usually provided in the authorization header, as a Bearer token. In this brief article, I got deep into the anatomy of the json web tokens. What’s an access token? For What is the payload made up? ",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph:
          "The first part is composed for my Login Form and my register form. The stack I’m using here is React App in my frontend, no fancy tools, just pure CSS styles sheets. The otherwise the framework with express.js and axios instances to communicate with my data base, which is hosted into a AWS RDS MySQL.  If you are interested in the cool stuff inside these forms made thinking in user experience and screen reader, I invite you to read my latest article dedicated to UX.",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },

      {
        subtitleParagraph: "My Implementation",
        paragraph:
          "Previously I set up the endpoints. And list in this part. It’s important to point out the logic are separated in a kind of MVC model. Routes files to set up the endpoints. .",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },

      {
        subtitleParagraph:
          "Here’s the simplified version of my implementation:",
        paragraph:
          "This is the result of my Server.js file. I use an instance of express const app = express() and their app.use() method. With their corresponding route prefixes",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: undefined,
        paragraph: undefined,
        lista: [],
        codeSnippet: {
          codeBreakdown: [],
          codeTitleImg: "",
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2F_comp_server.png?alt=media&token=88d92234-4c42-4868-8e04-ca135c4c4581",
          balazo: undefined,
        },
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph: "",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2Ferror_handling.png?alt=media&token=93bc7a25-cfe7-427d-886f-992dcb5a85c3",
        },
        code: undefined,
      },
      {
        subtitleParagraph: "Self note:",
        paragraph: `authRoutes imported as import authRoutes from "./routes/authRoutes.js"; ← My Express router. It contains the specific routs for POST / login, POST/Registe.`,
        lista: [],
        codeSnippet: {
          codeBreakdown: [],
          codeTitleImg: "",
          codePreview: "",
          balazo: undefined,
        },
        code: undefined,
      },
      {
        subtitleParagraph: "Here you are my complete Router",
        paragraph: undefined,
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2Fcomplete-router-1.png?alt=media&token=dca16e23-f958-4566-be1c-da01e4bb9656",
        },
        code: undefined,
      },
      {
        subtitleParagraph: "Note to self:",
        paragraph:
          "HTTP request 🡪 app.use() 🡪  does my route start with “/api/users/auth”  🡪 authRoutes (takes the sub-route) 🡪 the controller is executed.",
        lista: [],
        codeSnippet: {
          codeBreakdown: [],
          codeTitleImg: "",
          codePreview: undefined,
          balazo: undefined,
        },
        code: undefined,
      },
      {
        subtitleParagraph: undefined,
        paragraph:
          "Same with user end points where I can add a new user, delete by username, update by id and so on and so forth",
        lista: [],
        codeSnippet: {
          codeBreakdown: [],
          codeTitleImg: " ",
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2F_user_routes_1.png?alt=media&token=e7b87474-6e90-4af5-b3ce-78f9704cc016",
          balazo: "Here you are my user router.",
        },
        code: undefined,
      },
      {
        subtitleParagraph: "KEY CONCEPT BOUT JWT",
        paragraph:
          "A key concept to understand is the anatomy of a JWT. A token is made up of three distinct parts, separated by dots; a Header, a Payload, and a signature — each Base64Url-encoded and joined by a period ( . ), resulting the following structure: HEADER.PAYLOAD.SIGNATURE.",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph:
          "The first part, the HEADER, contains metadata about the token itself — such as the token type and the hashing algorithm used to generate the signature. ",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph:
          "The second part is the Payload, which carries the actual data of the token. There are some recommended standard fields — known as claims — such as user information, expiration time, and issue date. However it’s important to avoid including sensitive information like passwords. In my case,  I only included  username, exp (expiration time), and iat (issued at). You could also add fields like roles or emails. But for the purpose of the practice, I kept simple.",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: `{
“iss”: “oauth”,
“sub”: “username”,
“exp”: 112434,
“iat”: 123413,
}
`,
        paragraph: undefined,
        lista: [],
        codeSnippet: {},
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph:
          "The last part is the Signature. When a JWT has been issued to the user - me- the authenticating server signs the token. And it’s basically the way to ensure the token can be reliable.",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph:
          "The way the signature works: the server needs a very, very, VERY secret value . In my case i generated a new random one with Node. It wasn’t necessary to install anything else. Just went to the console and typed node  — to go into Node and run the command line interface. Node has a built-in core module called crypto. Just type: ",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },

      {
        subtitleParagraph: "require(‘cryptp’).randomBytes(64).toString(‘hex’);",
        paragraph: "",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2F-as-crypto.png?alt=media&token=d832cd21-2768-4511-b656-c3bdec08f809",
        },
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph:
          "And, we can use this string as our access token secret value, and another one for our refresh token secret value. Skip the quotes inside the string copy and paste it into the .env file.",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2F_acces_token_new.png?alt=media&token=6e0cc1f2-58b6-44c9-8d49-b7b7d0e7aac4",
        },
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph:
          "Then. It will take the header and the payload and running through a hashing function to output a signature.  So far, token is done. But… how does the authorization work? How do I verify the signature of a token?",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph:
          "The process is: you send a request, and the server takes the Header and the Payload of the token, and produces a signature to compare vs the one the user —me— has provided.",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },

      {
        subtitleParagraph:
          "If both signatures match, that means the token hasn’t been altered. Otherwise, the authorization fails.",
        paragraph: "",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },

      {
        subtitleParagraph: "Note to self:",
        paragraph:
          " Go to jwt.io and paste the token. Another important concept is that tokens are not encrypted — they are base64-encoded, which means their content can be decoded and accessed by anyone. All the claims are available, which is why it’s important not to store sensitive information.  ",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph: "",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2F_token_encoded.png?alt=media&token=de619e71-2f12-4836-9bf1-584c84032fe1",
        },
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph:
          "Next, I’ll show you the setup of my token. I’ve decided to issue it through the authByNicknameAndPwd() function.",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2F_uno.png?alt=media&token=14b5ec77-275a-4e25-809a-e8c52d97352e",
        },
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph: undefined,
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2F_dos.png?alt=media&token=3f1a38d0-e713-4bac-94f3-c431d2647516",
        },
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph: undefined,
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2F_tre.png?alt=media&token=2191fabf-7420-4f7c-9f6c-14a893cb6e06",
        },
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph:
          "I’ve decided to store the refresh token in a cookie. While we know it’s not 100% XSS-proof, usign the httpOnly flag makes it inaccessible to JavaScript code —So, it’s still considerate a good practice. Here, I focused on setting my refresh token with a medium expiration time, and my access token with a short one — 15 minutes.",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph:
          "A look at my handleRefreshToken( ) function. This function will help me generate a new access token once the previous one has expired, by retrieving the refresh token.",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph: "",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2FhandleRefreshToken-img.png?alt=media&token=12740a62-c997-4508-9ff3-2d2f2e07743d",
        },
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph:
          "With my authController complete. Let’s take a a deeper look at my middleware to verify the token.",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph: "",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2Fverify_jwt.png?alt=media&token=a1f73725-01d0-43c4-b2d9-2e036ca01b11",
        },
        code: undefined,
      },
      {
        subtitleParagraph: "Self note about the code does: ",
        paragraph:
          "Reads the Authorization header 🡪 extracts the  token 🡪 verify the accessToken 🡪 if valid→ authorizes and lets the request through 🡪 if not → throws an status 401 / 403  forbidden  error.",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph:
          "As a practice, I decided to test that the authorization flow  worked  as planned . So in  Postman. I tested the login and generated my token. The server response is received as JSON  — below we can see it returns the access token and a success message. ",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2F-post-man-does.png?alt=media&token=6dfa832d-c9c9-4e8f-a4d8-f5c455cdcd84",
        },
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph:
          "As parameters to fetch the main data of my user, I took the username and the access  token issued  at login.  I set the access token in the auth section of Postman as Bearer token.  As a result , by passing a legitimate token , the find-username route allows me  to retrieve the main data — such a username, email, profile_pic_username , given name etc.",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph: "",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2F-second-postman.png?alt=media&token=207861ae-0389-43f5-a8a5-077c0c4942a4",
        },
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph:
          "Once my access token expired, I was no longer able to access the userdata . Indeed , it worked as  expected, my server responded with a 403 Forbidden status.",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2Ftoken_expired.png?alt=media&token=fb506c37-d9e5-43b9-99eb-3d44a3ff42e3",
          balazo:
            "For practical purposes, I set 1 minute for the token expiration. ",
        },
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph: "",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2F_minutes-token.png?alt=media&token=1c245013-6e0e-401e-8630-5ab22b4a137b",
        },
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph:
          "And it works in every single route I’ve decided to protect, adding the header of the token in my request. verifyJWT",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph:
          "On the front-end side, in my service layer, the findUser function takes the username and the access token as arguments, and sends POST request to the /users/find-username route, attaching the access token in the Authorization headers as a Bearer token.",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph: "",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2FfindUser.png?alt=media&token=ccda9c2e-5657-470b-8411-5b7c3fabc582",
        },
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph: `
Before introducing you to the concept of interceptor with Axios instances, I’d like to point out a problem I faced —and it was crucial to my deeper understanding of the process of issuing a new access token with the refresh token. In my backend-end i have a function called handleRefreshToken (), but this function doesn’t trigger on it’s own —it must wait for a trigger to issue a new access token. This is a responsibility my client must handle, and this is exactly where interceptors come into play. Where should I handle it? With an Axios interceptor. The key concept here is this happen automatically, without the user noticing.
`,
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph:
          "I set up my axios instance with a common baseURL, after i updated some path routes in my endpoints, to ensure the requests are handled correctly and avoid, and avoid unnecessary axios instances.",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph: "",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2F_axios_setup.png?alt=media&token=44d5c642-1153-4e0b-952f-5335eb2a4ac8",
        },
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph:
          "Since my access token will be in a global context, I decided to create a custom hook in order to allow sharing my token state and its setter function — so my front-end services can access both, the state and the setter.",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph:
          "Since my authService , where its methods  are defined , is a plain object. I cannot call my custom hook directly to use these props. In another scenario I could do it with  const {acessToken, setAccessToke} = useAuthUser(); , but in this case i can only pass them from my async function — Y así yo puedo hacer uso de setAccessToken",
        paragraph: "and that’s how it all works.",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph: "",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2FloginUserFun.png?alt=media&token=40b85110-9b0e-4103-b059-22498485c0cf",
          balazo: "In line 78. I can make use of setAccessToken ();",
        },
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph: "",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2FauthService.png?alt=media&token=4d300e0e-8825-4ba7-a2e2-ab8a7ea2d5d9",
          balazo:
            "For the refresh access token case, I’ll use it directly from my custom hook useAxiosInterceptor( );",
        },
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph: "",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2FuseAxiosInteceptors.png?alt=media&token=4cc2ef67-9225-4e8d-ae72-a180c362c04c",
        },
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph: "",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2FuseAxiosInteceptors_2.png?alt=media&token=4589f08b-b161-437b-ab45-35a6625c59f4",
        },
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph: "",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2FuseAxiosInteceptors_3.png?alt=media&token=d3a81111-96ec-444f-98a3-7044669fcf41",
          balazo:
            "It’s important to ensure I pass the setter function from my access token.",
        },
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph: "",
        lista: [],
        codeSnippet: {
          codePreview:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2F_articulo_jwt%2F_refreshToken_final.png?alt=media&token=84f5ebf5-80dd-4c48-8a61-d62eee686c09",
        },
        code: undefined,
      },

      {
        subtitleParagraph: "",
        paragraph: `
Whit this my request no longer work the same way. The intention of my interceptors  — both request and response —is to intercept HTTP request without repeating the same logic on every single call. With this approach, I avoid manually setting:
`,
        lista: [
          {
            txt_item: "config.headers.Authorization = Bearer $accessToken",
            subList: [],
          },
          {
            txt_item:
              "Without my interceptors function. I’d have to do something like this code, in every single request:",
            subList: ["const token = getToken();"],
          },
        ],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph: "",
        paragraph: `await api.get("/route", {
headers: {
Authorization:Bearer ${"token"},
},
});


        `,
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
      {
        subtitleParagraph:
          "This is my general summary of the authorization process that I decided to implement in my web app mubi::pandasneezing. While this is not a “How to implement access tokens: the ultimate guide” type article — it’s a summary of what I consider essential when implementing JWT with this stack. There may be improvements, Which I’ll be sharing in the coming days.However, that’s why the first version was important to me, as a key milestone to write this kind of article, written by me to myself. And anyone whos reading",
        paragraph: "",
        lista: [],
        codeSnippet: {},
        code: undefined,
      },
    ],
  },
];
